@use 'quickstart/theme' as *;

.stack {
  display: flex;

  &[data-row] {
    flex-direction: row;

    // Row items
    & > *:not(hr, :first-child) {
      padding-left: var(--spacing); // component inline style
    }
    &[data-divided] > *:not(hr, :last-child),
    &[data-end-capped] > *:nth-last-child(2):not(hr) {
      padding-right: var(--spacing); // component inline style
    }

    // Row dividers (vertical bar)
    & > hr {
      // Do not set height:100% here because it results in 0.6667px. The default
      // of align-items:stretch in a flex container has the desired result.
      width: 0;
      margin: 0;
      border-left: var(--divider); // component inline style
    }
    & > hr:first-child {
      border-left: var(--start-cap); // component inline style
    }
    & > hr:last-child {
      border-left: var(--end-cap); // component inline style
    }
  }

  &:not([data-row]) {
    flex-direction: column;

    // Column items
    & > *:not(hr, :first-child) {
      padding-top: var(--spacing); // component inline style
    }
    &[data-divided] > *:not(hr, :last-child),
    &[data-end-capped] > *:nth-last-child(2):not(hr) {
      padding-bottom: var(--spacing); // component inline style
    }

    // Column dividers (horizontal bar)
    & > hr {
      width: 100%;
      height: 0;
      margin: 0;
      border-top: var(--divider); // component inline style
    }
    & > hr:first-child {
      border-top: var(--start-cap); // component inline style
    }
    & > hr:last-child {
      border-top: none;
      border-bottom: var(--end-cap); // component inline style
    }
  }
}
